import React from 'react'
import { Link } from 'react-router-dom'

export interface IBreadcrumbItem {
  name: string
  path: string
}

export interface BreadcrumbItemProps {
  item: IBreadcrumbItem
  active: boolean
}

const BreadCrumbItem = (props: BreadcrumbItemProps) => {
  return props.active ? (
    <></>
  ) : (
    <>
      <li>
        <Link to={props.item.path}>{props.item.name}</Link>
      </li>
    </>
  )
}
export default BreadCrumbItem
